var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_5","name":"5","data-vcode":"NUMBER_5","aria-label":"5 JKL"}},[_c('div',{staticClass:"digit"},[_vm._v("5")]),_c('div',{staticClass:"letters"},[_vm._v("JKL")])])
}]

export { render, staticRenderFns }